import { Client, ClientContact, Product, Invoice, BusinessSettings, ClientJob, AttachmentDocument, TimelineEvent } from '../types';

export const mockBusinessSettings: BusinessSettings = {
  id: 'bs_1',
  businessName: 'Acme Digital Services',
  abn: '12 345 678 901',
  addressLine1: '100 Tech Avenue',
  suburb: 'Sydney',
  state: 'NSW',
  postcode: '2000',
  country: 'Australia',
  email: 'accounts@acmedigital.com.au',
  phone: '02 1234 5678',
  website: 'www.acmedigital.com.au'
};

export const mockClients: Client[] = [
  {
    id: 'c_1',
    name: 'Jane Doe',
    companyName: 'TechCorp PTY LTD',
    abn: '98 765 432 109',
    email: 'jane@techcorp.com.au',
    additionalEmails: 'accounts@techcorp.com.au',
    phone: '0400 000 000',
    addressLine1: '1 Innovation Way',
    suburb: 'Melbourne',
    state: 'VIC',
    postcode: '3000',
    country: 'Australia',
    currency: 'AUD',
    taxTreatment: 'gst_10',
    paymentTerms: '14 Days',
    notes: 'Premium client',
    status: 'active',
    createdAt: new Date(Date.now() - 30 * 86400000).toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: 'c_2',
    name: 'John Smith',
    companyName: 'Global Exports Inc',
    abn: '',
    email: 'john@globalexports.com',
    additionalEmails: '',
    phone: '+1 555 123 4567',
    addressLine1: '100 Wall St',
    suburb: 'New York',
    state: 'NY',
    postcode: '10005',
    country: 'USA',
    currency: 'USD',
    taxTreatment: 'export',
    paymentTerms: '30 Days',
    notes: 'US Based client',
    status: 'active',
    createdAt: new Date(Date.now() - 60 * 86400000).toISOString(),
    updatedAt: new Date().toISOString()
  }
];

export const mockContacts: ClientContact[] = [
  {
    id: 'cc_1',
    clientId: 'c_1',
    name: 'Accounts Payable',
    role: 'Finance Team',
    email: 'ap@techcorp.com.au',
    phone: '03 9999 8888',
    isPrimary: false,
    includeOnInvoices: true,
    contactType: 'accounts',
    notes: 'Send all invoices here.'
  }
];

export const mockProducts: Product[] = [
  {
    id: 'p_1',
    name: 'Web Development Retainer',
    sku: 'WEB-RET-01',
    description: 'Monthly web development and maintenance retainer.',
    category: 'Services',
    unitPrice: 2500,
    currency: 'AUD',
    gstTreatment: 'gst_10',
    isRecurring: true,
    billingFrequency: 'monthly',
    publicNote: 'Includes up to 20 hours of development.',
    internalNote: 'Track hours in Toggl.',
    status: 'active',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: 'p_2',
    name: 'Domain Registration',
    sku: 'DOM-REG-01',
    description: 'Annual domain name registration fee.',
    category: 'Software',
    unitPrice: 50,
    currency: 'AUD',
    gstTreatment: 'gst_10',
    isRecurring: true,
    billingFrequency: 'annual',
    publicNote: '',
    internalNote: 'Auto-renews via Namecheap.',
    status: 'active',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  }
];

export const mockJobs: ClientJob[] = [
  {
    id: 'job_1',
    clientId: 'c_1',
    jobName: 'E-commerce Website Redesign',
    jobType: 'website',
    status: 'active',
    startDate: new Date(Date.now() - 7 * 86400000).toISOString(),
    endDate: new Date(Date.now() + 30 * 86400000).toISOString(),
    description: 'Complete redesign of TechCorp e-commerce platform',
    internalNotes: 'High priority project with tight deadline',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  },
  {
    id: 'job_2',
    clientId: 'c_1',
    jobName: 'API Automation Integration',
    jobType: 'automation',
    status: 'completed',
    startDate: new Date(Date.now() - 60 * 86400000).toISOString(),
    endDate: new Date(Date.now() - 30 * 86400000).toISOString(),
    description: 'Automated data sync between systems',
    internalNotes: 'Successfully delivered on time',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  }
];

export const mockAttachments: AttachmentDocument[] = [
  {
    id: 'att_1',
    clientId: 'c_1',
    jobId: 'job_1',
    invoiceId: 'inv_1',
    fileName: 'Website_Redesign_Proposal.pdf',
    fileType: 'application/pdf',
    fileSize: 2457600,
    fileReference: 'proposal_job_1.pdf',
    category: 'proposal',
    visibility: 'client',
    includeWithInvoice: true,
    uploadedDate: new Date().toISOString(),
    uploadedBy: 'system',
    notes: 'Initial proposal document',
    archived: false
  },
  {
    id: 'att_2',
    clientId: 'c_1',
    jobId: 'job_1',
    invoiceId: undefined,
    fileName: 'Internal_SOW_v2.pdf',
    fileType: 'application/pdf',
    fileSize: 1894400,
    fileReference: 'sow_job_1_internal.pdf',
    category: 'internal',
    visibility: 'internal',
    includeWithInvoice: false,
    uploadedDate: new Date().toISOString(),
    uploadedBy: 'system',
    notes: 'Internal statement of work',
    archived: false
  }
];

export const mockInvoices: Invoice[] = [
  {
    id: 'inv_1',
    invoiceNumber: 'INV-0001',
    clientId: 'c_1',
    issueDate: new Date().toISOString(),
    dueDate: new Date(Date.now() + 14 * 86400000).toISOString(),
    status: 'sent',
    currency: 'AUD',
    items: [
      {
        id: 'item_1',
        description: 'Web Development',
        quantity: 1,
        unitPrice: 5000,
        discount: 0,
        taxTreatment: 'gst_10',
        taxRate: 0.10,
        subtotal: 5000,
        taxAmount: 500,
        total: 5500
      }
    ],
    pdfSnapshotIds: [],
    subtotal: 5000,
    taxAmount: 500,
    total: 5500,
    amountPaid: 0,
    balanceDue: 5500,
    notes: 'Thank you for your business.',
    termsSnapshot: 'Standard payment terms are 14 days from date of invoice.',
    internalNotes: '',
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString()
  }
];

export const mockTimelineEvents: TimelineEvent[] = [
  {
    id: 'evt_1',
    entityType: 'job',
    entityId: 'job_1',
    eventType: 'created',
    description: 'Job "E-commerce Website Redesign" created',
    createdAt: new Date().toISOString(),
    createdBy: 'system'
  },
  {
    id: 'evt_2',
    entityType: 'attachment',
    entityId: 'att_1',
    eventType: 'added',
    description: 'Proposal document uploaded',
    createdAt: new Date().toISOString(),
    createdBy: 'system'
  }
];

export const seedDatabase = () => {
  if (!localStorage.getItem('invoiceflow_business_profile')) {
    localStorage.setItem('invoiceflow_business_profile', JSON.stringify(mockBusinessSettings));
  }
  if (!localStorage.getItem('invoiceflow_clients')) {
    localStorage.setItem('invoiceflow_clients', JSON.stringify(mockClients));
  }
  if (!localStorage.getItem('invoiceflow_contacts')) {
    localStorage.setItem('invoiceflow_contacts', JSON.stringify(mockContacts));
  }
  if (!localStorage.getItem('invoiceflow_products')) {
    localStorage.setItem('invoiceflow_products', JSON.stringify(mockProducts));
  }
  if (!localStorage.getItem('invoiceflow_jobs')) {
    localStorage.setItem('invoiceflow_jobs', JSON.stringify(mockJobs));
  }
  if (!localStorage.getItem('invoiceflow_attachments')) {
    localStorage.setItem('invoiceflow_attachments', JSON.stringify(mockAttachments));
  }
  if (!localStorage.getItem('invoiceflow_timeline')) {
    localStorage.setItem('invoiceflow_timeline', JSON.stringify(mockTimelineEvents));
  }
  if (!localStorage.getItem('invoiceflow_invoices')) {
    localStorage.setItem('invoiceflow_invoices', JSON.stringify(mockInvoices));
  }
};